import memoize from 'memoizee';
import config from '@/constants/config'
import { IS_DEV } from '@/constants/AppConstants'
import { getMainPoolsStats, getCryptoPoolsStats, getSubgraphStats } from '@/utils/stats';
import getPoolUsdFigure from './getPoolUsdFigure';
import pools, { poolIds } from '../../constants/pools';
import { arrayToHashmap } from '@/utils/helpers';

const initialVolumesValues = arrayToHashmap(pools.map(({ id }) => [id, [-1, -1]]));

const toStatsKeyResolver = (normalizedKey) => {
    const statsKey = (
        (config.blockchainId === 'ethereum' && normalizedKey === 'ren') ? 'ren2' :
        normalizedKey === 'sbtc' ? 'rens' :
        normalizedKey === 'iearn' ? 'y' :
        normalizedKey === 'susdv2' ? 'susd' :
        normalizedKey
    );

    return statsKey;
}

// Old way to retrieve APY and volume stats
const getOldStats = async () => {
    const stats = await getMainPoolsStats();
    const cryptoStats = config.blockchainId === 'ethereum' ?
        await getCryptoPoolsStats() :
        undefined;

    const volumes = initialVolumesValues;

    for (let [key, value] of Object.entries(volumes)) {
        if(volumes[key] && volumes[key][0] == -1) {
            const volume = stats.volume[toStatsKeyResolver(key)];

            const pool = pools.find(({ id }) => id === key);
            if (cryptoStats?.volume?.[pool.id]) {
              volumes[key][0] = cryptoStats.volume[pool.id];
              volumes[key][1] = cryptoStats.volume[pool.id];
            } else {
              volumes[key][0] = await getPoolUsdFigure(volume, pool) || 0;
              volumes[key][1] = volume || 0;
            }

        }
    }

    const daily_apy = [];
    const weekly_apy = [];
    const monthly_apy = [];
    const apy = [];

    poolIds.forEach((poolId) => {
        const statsKey = toStatsKeyResolver(poolId);
        if (cryptoStats?.volume?.[statsKey]) {
          daily_apy.push((cryptoStats.apy.day[statsKey] * 100).toFixed(2))
          weekly_apy.push((cryptoStats.apy.week[statsKey] * 100).toFixed(2))
          monthly_apy.push((cryptoStats.apy.month[statsKey] * 100).toFixed(2))
            if (cryptoStats.apy.total) apy.push((cryptoStats.apy.total[statsKey] * 100).toFixed(2))
        } else {
            if (poolId == 'usdn') {
              //show weekly as daily for usdn cause of claiming
              daily_apy.push((stats.apy.week[statsKey] * 100).toFixed(2))
            } else {
              daily_apy.push((((stats.apy.day[statsKey] > 0) ? stats.apy.day[statsKey] : 0) * 100).toFixed(2))
            }
          weekly_apy.push((stats.apy.week[statsKey] * 100).toFixed(2))
          monthly_apy.push((stats.apy.month[statsKey] * 100).toFixed(2))
        if (stats.apy.total) apy.push((stats.apy.total[statsKey] * 100).toFixed(2))
        }

    });

    return {
        volumes,
        daily_apy,
        weekly_apy,
        monthly_apy,
        apy,
    };
};

// New way to retrieve APY and volume stats
const getNewStats = async () => {
    const { data: { poolList: poolsStats } } = await getSubgraphStats();

    const stats = {
        volumes: {},
        daily_apy: [],
        weekly_apy: [],
        monthly_apy: [],
        apy: [],
    };

    pools.forEach(({ id, addresses: { swap: swapAddress } }) => {
        const lcSwapAddress = swapAddress.toLowerCase();
        const poolStats = poolsStats.find(({ address }) => address.toLowerCase() === lcSwapAddress);

        if (!poolStats) {
            const errorMessage = `Couldn't find pool address ${swapAddress} in subgraph stats data`;

            // if (IS_DEV) throw new Error(errorMessage);
            // else console.error(errorMessage);

            console.error(errorMessage);

            stats.volumes[id] = [null, null];
            stats.daily_apy.push(null);
            stats.weekly_apy.push(null);
        } else {
            stats.volumes[id] = [poolStats.volumeUSD, poolStats.rawVolume];
            stats.daily_apy.push(poolStats.latestDailyApy);
            stats.weekly_apy.push(poolStats.latestWeeklyApy);
        }
    });

    return stats;
};

const getAPY = memoize((
    config.subgraphStatsEndpoint ?
        getNewStats :
        getOldStats
), {
    promise: true,
    maxAge: 10 * 60 * 1000, // 10m
});

export default getAPY;
